import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  StyledContentBox,
  StyledModalContainer,
  StyledButton,
  StyledIconButton,
} from "./styles";
import ArrowForward from "@mui/icons-material/ArrowForward";

interface ConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  show,
  handleClose,
}) => {
  return (
    <StyledModalContainer
      aria-labelledby="modal-title"
      open={show}
      onClose={(_event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
    >
      <StyledContentBox>
        <StyledIconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </StyledIconButton>
        <Typography sx={{ padddingBottom: 10 }} variant="h1" id="modal-title">
          <FormattedMessage id="confirmationModalTitle" />
        </Typography>
        <Typography variant="subtitle1">
          <FormattedMessage id="confirmationModalSubtext" />
        </Typography>
        <StyledButton
          endIcon={<ArrowForward />}
          variant="outlined"
          onClick={handleClose}
          disabled={false}
          sx={{ maxWidth: 128 }}
        >
          Log In
        </StyledButton>
      </StyledContentBox>
    </StyledModalContainer>
  );
};

export default ConfirmationModal;
